import React from "react"
import {
  Flex,
  Kicker,
  GridItem,
  Grid,
  Image,
  Text,
  ModalWithButton,
  HeadingThree,
  Box,
  HelpCircleIcon,
} from "datastory-shared/ui"
import { Section, PageHeader } from "datastory-shared/sections"
import { useTranslation } from "datastory-shared/utils/i18n"

export const Heading = () => {
  const { t } = useTranslation(["og_page--6a7c04a9"])

  return (
    <>
      <Grid justifyContent="center" data-cy="heading">
        <GridItem colSpan={[4, 6, 8]} colStart={[null, null, 3]}>
          <Section variant="lg">
            <Flex justifyContent="center">
              <Image
                src={"/static/images/ui/services/glossary/syllabus_glasses.svg"}
                alt={"glossary-header-cover"}
                width={200}
                height={130}
              />
            </Flex>
            <Kicker textAlign="center" muted textTransform="uppercase">
              {t("master-the-lingo")}
            </Kicker>
            <PageHeader title={t("title")} lead={t("lead")} py={0} />
          </Section>
        </GridItem>
      </Grid>
      <Flex pb={["sm", "md", "lg"]} justifyContent={"center"}>
        <ModalWithButton
          button={{
            text: t("og_c:about-project"),
            leftIcon: <HelpCircleIcon />,
            variant: "ghost",
          }}
        >
          <Box px={["sm", "md", "lg"]}>
            <HeadingThree mb="md">{t("og_c:about-project")}</HeadingThree>
            <Text
              style={{ whiteSpace: "pre-wrap" }}
              dangerouslySetInnerHTML={{ __html: t("about-content") }}
            />
          </Box>
        </ModalWithButton>
      </Flex>
    </>
  )
}
